'use strict';//Indicating browser should run only in java script mod

var EMRTriggerCustomizationSharedModule = angular.module('EMR.TriggerCustomizationSharedModule', [])